<template>
  <div>
    <b-card no-body>
      <b-tabs content-class="mt-3" justified>
        <b-tab no-body title="Main Meter">
          <!-- meter info -->
          <b-row class="mb-3">
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Main Meter ?</label>
              <div><toggle-button class="mr-2" v-model="oModel.mtrMainUI.is_main_meter"
                  :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync /></div>
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter installed at which PVDB#</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrMain.meter_installed">
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter brand & model</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrMain.meter_brand_and_model">
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter Serial Number</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrMain.serial_number">
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter Firmware</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrMain.meter_firmware">
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter Batch Year</label>
              <input type="number" class="form-control" placeholder="" v-model="oModel.mtrMain.meter_batch_year">
            </b-col>
          </b-row>

          <!-- CT Ratio -->
          <hr class="hr" />
          <b-row class="mb-3">
            <b-col class="mb-2" md="12" lg="4" xl="4">
              <label class="mb-1 text-white" for="">CT Ratio</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrMain.ct_ratio">
            </b-col>
            <b-col class="mb-2" md="12" lg="4" xl="4">
              <label class="mb-1 text-white" for="">Actual</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrMain.actual">
            </b-col>
            <b-col class="mb-2" md="12" lg="4" xl="4">
              <label class="mb-1 text-white" for="">Meter</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrMain.meter">
            </b-col>
          </b-row>

          <!-- CT Ratio -->
          <hr class="hr" />
          <b-row class="mb-3">
            <b-col class="mb-3" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">RS485 cable installed from meter to comms box</label>
              <div>
                <b-row>
                  <b-col md="2" lg="2" xl="2">
                    <toggle-button class="mr-2" v-model="oModel.mtrMainUI.cable_installed_from_meter_to_comms_box"
                      :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync />
                  </b-col>
                  <b-col>
                    <input type="text" class="form-control" placeholder=""
                      v-model="oModel.mtrMain.cable_installed_from_meter_to_comms_box_remarks">
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="mb-3" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">RS485 cable installed between all inverters and terminated
                properly</label>
              <div>
                <b-row>
                  <b-col md="2" lg="2" xl="2">
                    <toggle-button class="mr-2"
                      v-model="oModel.mtrMainUI.cable_installed_between_inverters_and_terminated_properly"
                      :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync />
                  </b-col>
                  <b-col>
                    <input type="text" class="form-control" placeholder=""
                      v-model="oModel.mtrMain.cable_installed_between_remarks">
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="mb-3" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Power supply installed to IPC & sensors</label>
              <div>
                <b-row>
                  <b-col md="2" lg="2" xl="2">
                    <toggle-button class="mr-2" v-model="oModel.mtrMainUI.power_supply_installed_to_IPC_and_sensors"
                      :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync />
                  </b-col>
                  <b-col>
                    <input type="text" class="form-control" placeholder=""
                      v-model="oModel.mtrMain.power_supply_installed_to_IPC_and_sensors_remarks">
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="mb-3" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">RS485 cables labelled & terminated with ferrules</label>
              <div>
                <b-row>
                  <b-col md="2" lg="2" xl="2">
                    <toggle-button class="mr-2" v-model="oModel.mtrMainUI.cables_installed_and_terminated_with_ferrules"
                      :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync />
                  </b-col>
                  <b-col>
                    <input type="text" class="form-control" placeholder=""
                      v-model="oModel.mtrMain.cables_installed_and_terminated_with_ferrules_remarks">
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>

          <b-card-footer style="float: right;" v-if="is_editable">
            <base-button type="tn btn-sm base-button btn-primary" @click="save_main_meter()">Save Main
              Meter</base-button>
          </b-card-footer>
        </b-tab>

        <b-tab no-body title="Check Meter">
          <!-- meter info -->
          <b-row class="mb-3">
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Check Meter ?</label>
              <div><toggle-button class="mr-2" v-model="oModel.mtrCheckUI.is_check_meter"
                  :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync /></div>
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter installed at which PVDB#</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrCheck.meter_installed">
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter brand & model</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrCheck.meter_brand_and_model">
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter Serial Number</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrCheck.serial_number">
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter Firmware</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrCheck.meter_firmware">
            </b-col>
            <b-col class="mb-2" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Meter Batch Year</label>
              <input type="number" class="form-control" placeholder="" v-model="oModel.mtrCheck.meter_batch_year">
            </b-col>
          </b-row>

          <!-- CT Ratio -->
          <hr class="hr" />
          <b-row class="mb-3">
            <b-col class="mb-2" md="12" lg="4" xl="4">
              <label class="mb-1 text-white" for="">CT Ratio</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrCheck.ct_ratio">
            </b-col>
            <b-col class="mb-2" md="12" lg="4" xl="4">
              <label class="mb-1 text-white" for="">Actual</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrCheck.actual">
            </b-col>
            <b-col class="mb-2" md="12" lg="4" xl="4">
              <label class="mb-1 text-white" for="">Meter</label>
              <input type="text" class="form-control" placeholder="" v-model="oModel.mtrCheck.meter">
            </b-col>
          </b-row>

          <!-- CT Ratio -->
          <hr class="hr" />
          <b-row class="mb-3">
            <b-col class="mb-3" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">RS485 cable installed from meter to comms box</label>
              <div>
                <b-row>
                  <b-col md="2" lg="2" xl="2">
                    <toggle-button class="mr-2" v-model="oModel.mtrCheckUI.cable_installed_from_meter_to_comms_box"
                      :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync />
                  </b-col>
                  <b-col>
                    <input type="text" class="form-control" placeholder=""
                      v-model="oModel.mtrCheck.cable_installed_from_meter_to_comms_box_remarks">
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="mb-3" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">RS485 cable installed between all inverters and terminated
                properly</label>
              <div>
                <b-row>
                  <b-col md="2" lg="2" xl="2">
                    <toggle-button class="mr-2"
                      v-model="oModel.mtrCheckUI.cable_installed_between_inverters_and_terminated_properly"
                      :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync />
                  </b-col>
                  <b-col>
                    <input type="text" class="form-control" placeholder=""
                      v-model="oModel.mtrCheck.cable_installed_between_remarks">
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="mb-3" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">Power supply installed to IPC & sensors</label>
              <div>
                <b-row>
                  <b-col md="2" lg="2" xl="2">
                    <toggle-button class="mr-2" v-model="oModel.mtrCheckUI.power_supply_installed_to_IPC_and_sensors"
                      :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync />
                  </b-col>
                  <b-col>
                    <input type="text" class="form-control" placeholder=""
                      v-model="oModel.mtrCheck.power_supply_installed_to_IPC_and_sensors_remarks">
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="mb-3" md="12" lg="6" xl="6">
              <label class="mb-1 text-white" for="">RS485 cables labelled & terminated with ferrules</label>
              <div>
                <b-row>
                  <b-col md="2" lg="2" xl="2">
                    <toggle-button class="mr-2" v-model="oModel.mtrCheckUI.cables_installed_and_terminated_with_ferrules"
                      :labels="oField.toggle_yesno_value" :color="oField.toggle_yesno_color" :width="60" sync />
                  </b-col>
                  <b-col>
                    <input type="text" class="form-control" placeholder=""
                      v-model="oModel.mtrCheck.cables_installed_and_terminated_with_ferrules_remarks">
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>

          <b-card-footer style="float: right;" v-if="is_editable">
            <!-- <base-button @click="batch_process_add_ac_test_entry()" type="primary">Save Main Meter</base-button> -->
            <base-button type="tn btn-sm base-button btn-primary" @click="save_check_meter()">Save Check
              Meter</base-button>
          </b-card-footer>
        </b-tab>

      </b-tabs>
    </b-card>

    <!-- Modal loading / in progress -->
    <!-- <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="" :no-close-on-backdrop="true"> -->
    <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <!-- date | time | project name | site name -->
        <b-row class="mb-3">
          <b-col>
            <div class="text-center text-muted mb-4">
              <h1 class="text-white"><b>Loading in progress</b></h1>
            </div>
            <div class="text-center">
              <div style="color: #ffffff;">
                <!-- <span class="fa fa-spinner fa-spin fa-3x"></span> -->
                <span class="icon-spinner-cs"></span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>


<script>
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from "@/assets/js/config.js";
import ErrorFunctionMixin from "@/assets/js/errorFunctionMix.js";
import CustomLibHelper from "@/assets/js/customLibHelper.js";
import axios from "axios";

import { ToggleButton } from 'vue-js-toggle-button'

export default {
  props: ['shareData', 'meterData'],
  mixins: [ErrorFunctionMixin, CustomLibHelper],
  components: {
    ToggleButton,
  },
  data() {
    return {
      oDev: {
        debug: false,
      },
      oField: {
        toggle_yesno_color: { checked: '#75C791', unchecked: '#787785', disabled: '#CCCCCC' },
        toggle_yesno_value: { checked: 'Yes', unchecked: 'No' },
      },
      oModel: {
        mtrMain: {
          is_main_meter: 0,
          meter_installed: '',
          meter_brand_and_model: '',
          serial_number: '',
          meter_firmware: '',
          meter_batch_year: '',
          ct_ratio: '',
          actual: '',
          meter: '',
          cable_installed_from_meter_to_comms_box: 0,
          cable_installed_from_meter_to_comms_box_remarks: '',
          cable_installed_between_inverters_and_terminated_properly: 0,
          cable_installed_between_remarks: '',
          power_supply_installed_to_IPC_and_sensors: 0,
          power_supply_installed_to_IPC_and_sensors_remarks: '',
          cables_installed_and_terminated_with_ferrules: 0,
          cables_installed_and_terminated_with_ferrules_remarks: '',
        },
        mtrMainUI: {
          is_main_meter: false,
          cable_installed_from_meter_to_comms_box: false,
          cable_installed_between_inverters_and_terminated_properly: false,
          power_supply_installed_to_IPC_and_sensors: false,
          cables_installed_and_terminated_with_ferrules: false,
        },        
        mtrCheck: {
          is_check_meter: 1,
          meter_installed: '',
          meter_brand_and_model: '',
          serial_number: '',
          meter_firmware: '',
          meter_batch_year: '',
          ct_ratio: '',
          actual: '',
          meter: '',
          cable_installed_from_meter_to_comms_box: 1,
          cable_installed_from_meter_to_comms_box_remarks: '',
          cable_installed_between_inverters_and_terminated_properly: 1,
          cable_installed_between_remarks: '',
          power_supply_installed_to_IPC_and_sensors: 1,
          power_supply_installed_to_IPC_and_sensors_remarks: '',
          cables_installed_and_terminated_with_ferrules: 1,
          cables_installed_and_terminated_with_ferrules_remarks: '',
        },
        mtrCheckUI: {
          is_check_meter: false,
          cable_installed_from_meter_to_comms_box: false,
          cable_installed_between_inverters_and_terminated_properly: false,
          power_supply_installed_to_IPC_and_sensors: false,
          cables_installed_and_terminated_with_ferrules: false,
        }, 
      }
    }
  },
  computed: {
    is_editable() {
      return this.shareData.is_epc && this.shareData.status_tnc != 'APPROVED'
    }
  }, 
  methods: {
    //_ MAIN meter
    populate_main_meter() {
      if ( this.meterData.main != null ) {
        this.devMsg(this.oDev.debug, 'populate_main_meter', 'gs')
        this.devMsg(this.oDev.debug, this.meterData.main)

        this.oModel.mtrMain = this.meterData.main;
        this.convertToggle_main_meter(false);

        this.devMsg(this.oDev.debug, this.oModel.mtrMain, 'ge')
      }
    },
    convertToggle_main_meter( toDB = false ) {
      let dbModel = this.oModel.mtrMain;
      let uiModel = this.oModel.mtrMainUI;

      if ( toDB ) {
        dbModel.is_main_meter = this.convertToggle(uiModel.is_main_meter, toDB);
        dbModel.cable_installed_from_meter_to_comms_box = this.convertToggle(uiModel.cable_installed_from_meter_to_comms_box, toDB);
        dbModel.cable_installed_between_inverters_and_terminated_properly = this.convertToggle(uiModel.cable_installed_between_inverters_and_terminated_properly, toDB);
        dbModel.power_supply_installed_to_IPC_and_sensors = this.convertToggle(uiModel.power_supply_installed_to_IPC_and_sensors, toDB);
        dbModel.cables_installed_and_terminated_with_ferrules = this.convertToggle(uiModel.cables_installed_and_terminated_with_ferrules, toDB);
      } else {
        uiModel.is_main_meter = this.convertToggle(dbModel.is_main_meter, toDB);
        uiModel.cable_installed_from_meter_to_comms_box = this.convertToggle(dbModel.cable_installed_from_meter_to_comms_box, toDB);
        uiModel.cable_installed_between_inverters_and_terminated_properly = this.convertToggle(dbModel.cable_installed_between_inverters_and_terminated_properly, toDB);
        uiModel.power_supply_installed_to_IPC_and_sensors = this.convertToggle(dbModel.power_supply_installed_to_IPC_and_sensors, toDB);
        uiModel.cables_installed_and_terminated_with_ferrules = this.convertToggle(dbModel.cables_installed_and_terminated_with_ferrules, toDB);
      }
    },
    save_main_meter() {
      if (this.validate_main_meter()) {
        this.$refs['modal-loading-in-progress'].show();

        //_ convert toggle button value that is boolean to 0 | 1, adjusting to backend API
        this.convertToggle_main_meter(true);

        this.devMsg(this.oDev.debug, 'save_main_meter', 'gs');

        let api_url = apiDomain + 'qaqc/create_qaqc_main_meter/' + this.$route.params.id;
        if ( this.oModel.mtrMain.id != null ) {
          api_url = apiDomain + 'qaqc/update_qaqc_main_meter/' + this.$route.params.id;
        }

        this.devMsg(this.oDev.debug, api_url)
        this.devMsg(this.oDev.debug, this.oModel.mtrMain, 'ge');

        axios
          .post(api_url, this.oModel.mtrMain, { headers: getHeader() })
          .then((response) => {
            if (response.status === 200) {
              this.msg_notify_ok('<b>Update Main Meter Entry Successfully Created and Submitted.</b>');
            }
          })
          .catch((error) => {
            if (error.response) {
              // Handle error with response
              this.errorFunction(error, "Update Main Meter Entry Submit");
            } else {
              // Handle error without response
              this.msg_notify_sembcorp();
            }
          })
          .finally(() => {
            this.$refs['modal-loading-in-progress'].hide();
          });
      }
    },
    validate_main_meter() {
      let checker = false;
      if (
        !this.oModel.mtrMain.meter_installed ||
        !this.oModel.mtrMain.meter_brand_and_model ||
        !this.oModel.mtrMain.serial_number ||
        !this.oModel.mtrMain.meter_firmware ||
        !this.oModel.mtrMain.meter_batch_year ||
        !this.oModel.mtrMain.ct_ratio ||
        !this.oModel.mtrMain.actual ||
        !this.oModel.mtrMain.meter
      ) {
        let strModule = '[Main Meter]';
        if (!this.oModel.mtrMain.meter_installed) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +" Meter installed at which PVDB# is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrMain.meter_brand_and_model) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter brand & model is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrMain.serial_number) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter Serial Number is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrMain.meter_firmware) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter Firmware is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrMain.meter_batch_year) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter Batch Year is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrMain.ct_ratio) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"CT Ratio is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrMain.actual) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Actual is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrMain.meter) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter is a Mandatory Field.</b>");
        } else {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Please fill in all the Mandatory Fields.</b>");
        }
      } else {
        checker = true;
      }

      return checker;
    },

    //_ CHECK meter
    populate_check_meter() {
      if ( this.meterData.check != null ) {
        this.devMsg(this.oDev.debug, 'populate_check_meter', 'gs')
        this.devMsg(this.oDev.debug, this.meterData.check)

        this.oModel.mtrCheck = this.meterData.check;
        this.convertToggle_check_meter(false);

        this.devMsg(this.oDev.debug, this.oModel.mtrCheck, 'ge')

      }
    },
    convertToggle_check_meter( toDB = false ) {
      let dbModel = this.oModel.mtrCheck;
      let uiModel = this.oModel.mtrCheckUI;

      if ( toDB ) {
        dbModel.is_main_meter = this.convertToggle(uiModel.is_main_meter, toDB);
        dbModel.cable_installed_from_meter_to_comms_box = this.convertToggle(uiModel.cable_installed_from_meter_to_comms_box, toDB);
        dbModel.cable_installed_between_inverters_and_terminated_properly = this.convertToggle(uiModel.cable_installed_between_inverters_and_terminated_properly, toDB);
        dbModel.power_supply_installed_to_IPC_and_sensors = this.convertToggle(uiModel.power_supply_installed_to_IPC_and_sensors, toDB);
        dbModel.cables_installed_and_terminated_with_ferrules = this.convertToggle(uiModel.cables_installed_and_terminated_with_ferrules, toDB);
      } else {
        uiModel.is_main_meter = this.convertToggle(dbModel.is_main_meter, toDB);
        uiModel.cable_installed_from_meter_to_comms_box = this.convertToggle(dbModel.cable_installed_from_meter_to_comms_box, toDB);
        uiModel.cable_installed_between_inverters_and_terminated_properly = this.convertToggle(dbModel.cable_installed_between_inverters_and_terminated_properly, toDB);
        uiModel.power_supply_installed_to_IPC_and_sensors = this.convertToggle(dbModel.power_supply_installed_to_IPC_and_sensors, toDB);
        uiModel.cables_installed_and_terminated_with_ferrules = this.convertToggle(dbModel.cables_installed_and_terminated_with_ferrules, toDB);      
      }
    },    
    save_check_meter() {
      if (this.validate_check_meter()) {
        this.$refs['modal-loading-in-progress'].show();

        //_ convert toggle button value that is boolean to 0 | 1, adjusting to backend API
        this.convertToggle_check_meter(true);

        this.devMsg(this.oDev.debug, 'save_check_meter', 'gs');

        let api_url = apiDomain + 'qaqc/create_qaqc_check_meter/' + this.$route.params.id;
        if ( this.oModel.mtrCheck.id != null ) {
          api_url = apiDomain + 'qaqc/update_qaqc_check_meter/' + this.$route.params.id;
        }

        this.devMsg(this.oDev.debug, api_url)
        this.devMsg(this.oDev.debug, this.oModel.mtrCheck, 'ge');

        axios
          .post(api_url, this.oModel.mtrCheck, { headers: getHeader() })
          .then((response) => {
            if (response.status === 200) {
              this.msg_notify_ok('<b>Update Check Meter Entry Successfully Created and Submitted.</b>');
            }
          })
          .catch((error) => {
            if (error.response) {
              // Handle error with response
              this.errorFunction(error, "Update Check Meter Entry Submit");
            } else {
              // Handle error without response
              this.msg_notify_sembcorp();
            }
          })
          .finally(() => {
            this.$refs['modal-loading-in-progress'].hide();
          });
      }
    },
    validate_check_meter() {
      let checker = false;
      if (
        !this.oModel.mtrCheck.meter_installed ||
        !this.oModel.mtrCheck.meter_brand_and_model ||
        !this.oModel.mtrCheck.serial_number ||
        !this.oModel.mtrCheck.meter_firmware ||
        !this.oModel.mtrCheck.meter_batch_year ||
        !this.oModel.mtrCheck.ct_ratio ||
        !this.oModel.mtrCheck.actual ||
        !this.oModel.mtrCheck.meter
      ) {
        let strModule = '[Check Meter]';
        if (!this.oModel.mtrCheck.meter_installed) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +" Meter installed at which PVDB# is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrCheck.meter_brand_and_model) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter brand & model is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrCheck.serial_number) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter Serial Number is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrCheck.meter_firmware) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter Firmware is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrCheck.meter_batch_year) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter Batch Year is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrCheck.ct_ratio) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"CT Ratio is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrCheck.actual) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Actual is a Mandatory Field.</b>");
        } else if (!this.oModel.mtrCheck.meter) {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Meter is a Mandatory Field.</b>");
        } else {
          this.redErrorNotify("<b>Invalid Input : "+ strModule +"Please fill in all the Mandatory Fields.</b>");
        }
      } else {
        checker = true;
      }

      return checker;
    },
  },
  created() {
    this.devMsg(this.oDev.debug, 'created', 'gs')
    this.devMsg(this.oDev.debug, this.meterData, 'ge');

    this.populate_main_meter();
    this.populate_check_meter();
  },
  mounted() {
  },
  beforeMount() {
  }
}
</script>

<!-- form element -->
<style scoped>
/deep/ hr {
  background-color: white;
}

/deep/ .form-control {
  background-color: #2C545A;
  border-color: #2C545A;
  color: white;

  &:focus {
    background-color: #2C545A;
    border-color: #2C545A;
    /* color: white; */
  }

  &::placeholder {
    color: rgb(163, 163, 163);
  }
}

/deep/ .form-control {
  &:focus {
    &::placeholder {
      color: rgb(163, 163, 163);
    }
  }
}

/deep/ .input-group-text {
  background-color: #2C545A;
  ;
  color: white;

  &:focus {
    background-color: #2C545A;
    ;
    border-color: #1D4147;
    color: white;
  }
}

/deep/ input::-webkit-input-placeholder {
  color: #fff;
}

/deep/ input::-moz-input-placeholder {
  color: #fff;
}

/deep/ input::-ms-input-placeholder {
  color: #fff;
}

/deep/ .el-input .el-input__inner {
  background-color: #2C545A;
  color: #fff;
  border: 0px;
  border-radius: 10px;
  padding-top: 3px;
  padding-bottom: 2px;

  /* &::placeholder {
    color: white;
  } */
}

/deep/ .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #23504e;
}

/deep/ .el-select-dropdown {
  background-color: #306b74;
  margin: 0px;
}

/deep/ .el-select-dropdown__item {
  color: white;
  background-color: #183034;

  ::hover {
    background-color: #2C545A
  }

}

/deep/ .el-select {
  .el-input .el-input__inner {
    &::placeholder {
      color: white;
    }
  }

}

/deep/ .el-select__input {
  color: white;
  background-color: #2C545A;
}

/deep/ .el-select__input.hover,
.el-select__input:hover {
  background-color: #23504e;
}
</style>

<!-- tabs -->
<style scoped>
/deep/ .tabs {
  background-color: #24454a;
}

/*  .nav-tabs .nav-item.show .nav-link, .nav-tabs  */

/deep/ .nav-link.active {
  color: #ffffff !important;
  background-color: #2c585f !important;
  border-color: #ffffff #ffffff #24454a !important;
}

/deep/ .tab-content {
  padding: 10px;
}

/deep/ .card-footer {
  /* padding: 0.5rem 0.5rem; */
  padding-bottom: 15px;
  background-color: #24454a;
  border-top: 1px solid rgba(0, 0, 0, .05);
}
</style>

<!-- modal -->
<style scoped>
/deep/ .modal-content {
  background-color: #306b74 !important;
}

/deep/ .modal-body {
  background-color: #306b74 !important;
}

/deep/ .modal-row-header {
  padding-bottom: 20px;
}

/deep/ .modal-row-category {
  padding-top: 25px;
  padding-bottom: 0px;
}
</style>

<!-- dropdown action menu -->
<style scoped>
/deep/ .btn-dark,
.btn-dark:hover {
  color: #fff;
  background-color: #2c545a;
  border-color: #2c545a;
}

/deep/ .dropdown-menu {
  background-color: #23444a !important;
  border: 1px solid #ffffff;
}

/deep/ .dropdown-item {
  &:hover {
    background-color: #3a656b !important;
    color: #ffffff;
  }

  span {
    padding-left: 8px;
    vertical-align: super;
  }
}
</style>